import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Title from "./Title";
import { Card, CardContent, Grid } from "@mui/material";

export default function DayCard({ title, data }) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
          <Grid item>
            <React.Fragment>
              <Title marginLeft={1}>{title}</Title>
              <Typography component="p" variant="h4" marginLeft={2}>
                {data ? `${data} days` : `No data`}
              </Typography>
            </React.Fragment>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
